import AppDispatcher from '../../Dispatcher'
import HeaderConstants from './HeaderConstants'

class HeaderAction {
    headerPayload(response) {
        AppDispatcher.dispatch({ actionType: HeaderConstants.HEADER, response: response })
    }
}
export default new HeaderAction()